import React from "react"
import CloudCheck from "~/components/Icons/CloudCheck"
import { StatefulTooltip } from "baseui/tooltip"
import useDesignEditorContext from "~/hooks/useDesignEditorContext"

export default function () {
  const { currentDesign, setCurrentDesign } = useDesignEditorContext()
  const [name, setName] = React.useState(currentDesign.name || "")
  const measureRef = React.useRef<HTMLSpanElement | null>(null)
  const [width, setWidth] = React.useState(140)

  React.useEffect(() => {
    setName(currentDesign.name || "")
  }, [currentDesign.name])

  React.useEffect(() => {
    if (measureRef.current) {
      setWidth(Math.min(430, Math.max(90, measureRef.current.clientWidth + 22)))
    }
  }, [name])

  const handleChange = (value: string) => {
    setName(value)
    setCurrentDesign({ ...currentDesign, name: value })
  }

  return (
    <div className="ar-title">
      <input
        className="ar-title-input"
        value={name}
        placeholder="Design sem título"
        onChange={(e) => handleChange(e.target.value)}
        style={{ width: `${width}px` }}
        aria-label="Design name"
      />
      <span className="ar-title-measure" ref={measureRef}>
        {name || "Design sem título"}
      </span>

      <StatefulTooltip
        showArrow={true}
        content={() => (
          <div style={{ background: "#fff", color: "#0d1216", padding: "2px 4px" }}>Todas as alterações salvas</div>
        )}
      >
        <span className="ar-saved" title="Todas as alterações salvas">
          <CloudCheck size={18} />
        </span>
      </StatefulTooltip>
    </div>
  )
}
